export default __webpack_public_path__ + "static/media/prev-arrow.be2ad8cc.svg";